import { ZohoContact } from '../types';

import axiosInstance from './axiosInstance';

export async function getSalesReps() {
  const response = await axiosInstance.get(`/sales-reps`);

  return response.data as ZohoContact[];
}
